import { ChipSize } from './types';

export const tokens = {
    chip: {
        height: {
            [ChipSize.Smaller]: 24,
            [ChipSize.Small]: 30,
            [ChipSize.Medium]: 38,
            [ChipSize.Large]: 48,
        },
        borderWidth: 1,
    },
    icon: {
        size: {
            [ChipSize.Smaller]: 12,
            [ChipSize.Small]: 14,
            [ChipSize.Medium]: 16,
            [ChipSize.Large]: 18,
        },
    },
    interior: {
        gap: {
            [ChipSize.Smaller]: 6,
            [ChipSize.Small]: 8,
            [ChipSize.Medium]: 10,
            [ChipSize.Large]: 12,
        },
        padding: {
            [ChipSize.Smaller]: 8,
            [ChipSize.Small]: 12,
            [ChipSize.Medium]: 16,
            [ChipSize.Large]: 20,
        },
    },
};
